export default "__VITE_ASSET__BPebumLU__"